import { Button, Form, Input, message } from "antd";
import axios from "axios";
import React from "react";
import { useCookies } from "react-cookie";
import { useNavigate, Link } from "react-router-dom";
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import logo from '../component/image/logo.png';

const Login = () => {
  const navigate = useNavigate();
  const [, setCookie] = useCookies(["user"]);
  const [, setCookieToken] = useCookies(["accessToken"]);

  const loginUser = async (values) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/user/login`, values);
      setCookie("user", res?.data);
      setCookieToken("accessToken", res?.data?.token);
      message.success("Đăng nhập thành công!");
      navigate("/");
    } catch (err) {
      message.error("Tài khoản hoặc mật khẩu không đúng!");
    }
  };

  const onFinishFailed = () => {
    message.error("Bạn đang điền thiếu thông tin!");
  };

  const loginGmail = async (credentialResponse) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        { googleId: credentialResponse?.credential },
        { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }
      );
      setCookie("user", res?.data);
      message.success("Đăng nhập thành công!");
      navigate("/");
    } catch (err) {
      message.error("Tài khoản hoặc mật khẩu không đúng!");
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left Panel - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-[#0e4a61] via-[#1565a0] to-[#1e90ff] relative overflow-hidden items-center justify-center">
        {/* Decorative circles */}
        <div className="absolute top-20 left-20 w-72 h-72 bg-white/5 rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-white/5 rounded-full"></div>
        <div className="absolute top-1/2 left-1/3 w-40 h-40 bg-white/5 rounded-full"></div>

        <div className="relative z-10 text-center text-white px-12 max-w-lg">
          <img src={logo} alt="Logo" className="w-28 h-28 mx-auto mb-8 drop-shadow-2xl" />
          <h1 className="text-4xl font-extrabold mb-4">Effortless English</h1>
          <p className="text-blue-100 text-lg mb-8">Phương pháp học tiếng Anh tự nhiên, giúp bạn nói tiếng Anh tự tin chỉ sau vài tháng</p>
          <div className="flex justify-center gap-6">
            <div className="text-center">
              <div className="text-3xl font-extrabold">10K+</div>
              <div className="text-blue-200 text-sm">Học viên</div>
            </div>
            <div className="w-px bg-white/20"></div>
            <div className="text-center">
              <div className="text-3xl font-extrabold">100+</div>
              <div className="text-blue-200 text-sm">Bài học</div>
            </div>
            <div className="w-px bg-white/20"></div>
            <div className="text-center">
              <div className="text-3xl font-extrabold">4.8★</div>
              <div className="text-blue-200 text-sm">Đánh giá</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel - Login Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center bg-gradient-to-b from-[#f0f7ff] to-white px-6 py-12">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden text-center mb-8">
            <img src={logo} alt="Logo" className="w-20 h-20 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-800">Effortless English</h2>
          </div>

          {/* Form Card */}
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-10">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-extrabold text-gray-900 mb-2">Đăng Nhập</h2>
              <p className="text-gray-500">Chào mừng bạn quay trở lại!</p>
            </div>

            <Form
              onFinish={loginUser}
              onFinishFailed={onFinishFailed}
              name="login"
              layout="vertical"
              size="large"
            >
              <Form.Item
                name="email"
                rules={[{ required: true, message: 'Vui lòng nhập email!' }]}
              >
                <Input
                  prefix={<MailOutlined className="text-gray-400 mr-2" />}
                  placeholder="Email"
                  className="!rounded-xl !py-3 !px-4 !border-gray-200 hover:!border-blue-400 focus:!border-blue-500"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
              >
                <Input.Password
                  prefix={<LockOutlined className="text-gray-400 mr-2" />}
                  placeholder="Mật khẩu"
                  className="!rounded-xl !py-3 !px-4 !border-gray-200 hover:!border-blue-400 focus:!border-blue-500"
                />
              </Form.Item>

              <Button
                type="primary"
                htmlType="submit"
                block
                className="!h-12 !rounded-xl !bg-gradient-to-r !from-blue-500 !to-blue-700 !border-none !text-lg !font-semibold hover:!from-blue-600 hover:!to-blue-800 !shadow-lg !shadow-blue-500/25"
              >
                Đăng nhập
              </Button>
            </Form>

            {/* Divider */}
            <div className="flex items-center my-6">
              <div className="flex-1 h-px bg-gray-200"></div>
              <span className="px-4 text-sm text-gray-400">hoặc</span>
              <div className="flex-1 h-px bg-gray-200"></div>
            </div>

            {/* Google Login */}
            <div className="flex justify-center">
              <GoogleOAuthProvider clientId="253239939416-cv56na10g3t9trr8jaij772bv2frh7u0.apps.googleusercontent.com">
                <GoogleLogin
                  onSuccess={loginGmail}
                  onError={(err) => console.log(err)}
                  shape="pill"
                  theme="outline"
                  size="large"
                  width="360"
                  text="signin_with"
                  locale="vi"
                />
              </GoogleOAuthProvider>
            </div>

            {/* Footer Links */}
            <div className="mt-8 text-center">
              <p className="text-gray-500 text-sm">
                Chưa có tài khoản?{' '}
                <Link to="/contact" className="text-blue-600 font-semibold hover:text-blue-700">
                  Liên hệ đăng ký
                </Link>
              </p>
            </div>
          </div>

          {/* Back to home */}
          <div className="text-center mt-6">
            <Link to="/" className="text-gray-400 hover:text-gray-600 text-sm transition-colors">
              ← Quay về trang chủ
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
